module.exports = __webpack_public_path__ + "static/robotic-logo-9345f8a6a69d66a2baa30ebfdcf2ab09.svg";